import { Badge, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { chain, map } from "lodash";

import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { RouteLabel } from "./RouteLabel";
import { View } from "../../View";
import clsx from "clsx";
import { collectionFieldToIcon } from "../../../consts/collections";
import { memo } from "react";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  volumeContainer: {
    pointerEvents: "none",
    minWidth: "26px",
    lineHeight: "16px",
    fontSize: "0.75rem",
    textAlign: "center",
    fontWeight: "bold",
    color: "black",
    cursor: "pointer",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
  },
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "2px",
  },
  container: {
    minWidth: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  rowContainer: {
    padding: "0px 2px",
    height: "16px",
    lineHeight: "16px",
  },
  icon: {
    color: palette.typography.white.high,
    textAlign: "center",
    fontSize: "11px",
    lineHeight: "12px",
  },
  iconContainer: {
    display: "flex",
    paddingLeft: "3px",
    alignItems: "center",
    height: "16px",
  },
  iconSize: {
    height: "12px",
    width: "12px",
  },
  top: {
    borderRadius: "0 0.125rem 0 0",
  },
  bottom: {
    borderRadius: "0 0 0.125rem 0",
  },
  fullHeight: {
    height: "100%",
  },
  colorPrimary: {
    backgroundColor: palette.typography.white.solid,
    color: palette.typography.black.high,
  },
  routeLabel: {
    padding: "2px",
  },
});

export const CollectionOverridesMarker = memo(({ collection, mismatches }) => {
  const styles = useStyles();

  const validCollections = chain(collection)
    .pickBy((i) => i !== null)
    .keys()
    .value();

  if (!validCollections.length && !mismatches) return null;

  return (
    <View className={styles.markerContainer}>
      <View>
        <Grid container direction={"row"} className={styles.container}>
          {mismatches ? (
            <Grid item>
              <Badge
                badgeContent={mismatches}
                invisible={!!!mismatches}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                color={"primary"}
                classes={{ colorPrimary: styles.colorPrimary }}
              >
                <View className={styles.routeLabel}>
                  <RouteLabel routeCode={"T"} />
                </View>
              </Badge>
            </Grid>
          ) : null}
          {validCollections.length ? (
            <Grid item>
              <Grid item container direction={"column"}>
                {map(validCollections, (key, index) => {
                  return (
                    collection[key] !== null && (
                      <Grid
                        key={index}
                        item
                        container
                        xs
                        className={styles.rowContainer}
                        direction={"row"}
                      >
                        <Grid
                          item
                          container
                          direction={"row"}
                          justifyContent={"flex-end"}
                          spacing={0}
                          alignContent={"center"}
                        >
                          <Grid item>
                            <Grid
                              item
                              container
                              alignContent={"center"}
                              className={styles.fullHeight}
                            >
                              {key === "saturnAuto" ? (
                                <PhoneIphoneIcon className={styles.iconSize} />
                              ) : (
                                collection[key]
                              )}
                            </Grid>
                          </Grid>
                          <Grid item className={styles.iconContainer}>
                            <View
                              className={clsx(
                                styles.icon,
                                styles.iconSize,
                                index === 0 && styles.top,
                                index === validCollections.length - 1 &&
                                  styles.bottom
                              )}
                              style={{
                                backgroundColor:
                                  key === "saturnAuto"
                                    ? collectionFieldToIcon[
                                        key + collection[key]
                                      ]?.colour
                                    : collectionFieldToIcon[key]?.colour,
                              }}
                            >
                              {key === "saturnAuto"
                                ? collectionFieldToIcon[key + collection[key]]
                                    ?.icon
                                : collectionFieldToIcon[key]?.icon}
                            </View>
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  );
                })}
              </Grid>
            </Grid>
          ) : null}
        </Grid>
        <View className={styles.arrowContainer}>
          <View className={styles.arrow} />
        </View>
      </View>
    </View>
  );
});
